// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"190":"6eda44a3","453":"2241fe5c","726":"6ee00923","775":"63446537"}[chunkId] + ".chunk.js";
};